import api from './api';
import { ResourceUsageSummary } from '@/types/resource-usage';

export type { ResourceUsageItem, ResourceUsage, ResourceUsageSummary } from '@/types/resource-usage';

class AdminResourceUsageService {
  async getUserResourceUsage(userId: number): Promise<ResourceUsageSummary> {
    const response = await api.get<any>(`/admin/resource-usage/${userId}`);
    return response.data.data;
  }
}

export const adminResourceUsageService = new AdminResourceUsageService();
